import react, { ReactElement, VFC } from 'react';
import Modal from 'react-bootstrap/Modal';

import {PetskedTitle } from '../Heading/PetskedTitle';
import { Button } from '../Button';

import './ConfirmationDialogV2.scss';
const ConfirmationDialogV2: VFC<{
  title: string;
  description: string;
  noButtonLabel: string;
  yesButtonLabel: string;
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  children: ReactElement;
  hideButtons?:boolean;
  isRefund?: boolean;
}> = ({
  title,
  description,
  open,
  onCancel,
  onConfirm,
  noButtonLabel,
  yesButtonLabel,
  children,
  hideButtons,
  isRefund
}) => {
  return (
    <>
      <Modal show={open} onHide={onCancel} className="petsked-modal-dialog confirmation-dialog-v2">
        <Modal.Header closeButton className={`${hideButtons ? 'ml-20' : ''}`}>
          <PetskedTitle size="sm" title={title} description={description} />
        </Modal.Header>
        <Modal.Body>
          {children && <div className={`confirmation-dialog-container ${isRefund ? 'refund' : ''}`}>{children}</div>}
        </Modal.Body>
       {!hideButtons && <Modal.Footer className={`${isRefund ? 'refund-footer' : ''}`}>
          <Button variant="inverse" size="lg" onClick={onCancel}>
            {noButtonLabel}
          </Button>
          <Button variant="primary" size="lg" onClick={onConfirm}>
            {yesButtonLabel}
          </Button>
        </Modal.Footer>}
      </Modal>
    </>
  );
};

export default ConfirmationDialogV2;
